import { Link, useParams } from "react-router";
import { useAuth } from "../context/auth";

export function WelcomePage() {
	const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
	const { user } = useAuth();

	return (
		<div className="max-w-sm mx-auto mt-8 text-center">
			<h1 className="text-2xl font-bold text-gray-900 mb-4">
				Welcome{user?.name ? `, ${user.name}` : ""}!
			</h1>
			<p className="text-gray-600 mb-6">
				Your account is ready. Let's get started.
			</p>
			<Link
				to={`/${workspaceSlug}/`}
				className="inline-block rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
			>
				Get Started
			</Link>
		</div>
	);
}
